module.exports = __webpack_public_path__ + "static/media/emoji-off.ea7b1bbe.svg";